import { Loader2 } from 'lucide-react';
import React from 'react';

/**
 * Small inline pill rendered when a background refetch is in flight (the 30s
 * polling cycle or a filter-change refetch with cached data still visible).
 * Distinguishes "data is being refreshed" from initial-load skeleton state.
 */
export function RefreshIndicator() {
  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"
      aria-live="polite"
      role="status"
    >
      <Loader2 className="size-3 animate-spin" />
      Refreshing…
    </span>
  );
}
